import send from '../request';
import { queryString } from '../request/md5sign';

// 国家列表（含 国家logo、国家名称、国家 dialling_code 等）
export function getArea(data = {}, loading = true) {
  return send({ url: '/ipp/v3/public/area', method: 'POST', data, options: { loading } });
}

// 级联查询地区（省市区名称查询）
export function publicAreaByName(data = {}, loading: boolean = true) {
  return send({ url: '/ipp/v3/public/area-by-name', method: 'POST', data, options: { loading } });
}

// 经营品类 - 全品类
export function enumCatList(data = {}) {
  return send({ url: '/ipp/v3/enum/cat-list', method: 'POST', data });
}

// 获取用户信息
export function getUserInfoApi(data = {}) {
  return send({ url: '/ipp/v3/user/current-user', method: 'POST', data });
}

// 获取用户信息
export function publicLoginForSign(data = {}, queryParams = {}) {
  return send({ url: '/ipp/v3/public/login-for-sign?' + queryString(queryParams), method: 'POST', data });
}

// 菜单列表
export function commonMenus(data = {}) {
  return send({ url: '/ipp/v3/common/menus', method: 'POST', data });
}

// 币种汇率获取
export function publicCurrency(data = {}) {
  return send({ url: '/ipp/v3/public/currency', method: 'POST', data });
}

//供应商
export function getSuppliers(data = {}) {
  return send({ url: '/ipp/v3/enum/suppliers', method: 'POST', data });
};

// 获取ossToken
export function getOssToken(params = {}) {
  return send({ url: '/ipp/v3/public/oss-token', method: 'GET', params });
}

// 公司仓库列表
export function userAddressWarehouseList(params = {}) {
  return send({ url: '/ipp/user-address/warehouse-list', method: 'POST', data: params });
}

// PV统计接口
export function apiLog(params = {}) {
  return send({ url: '/api/log', method: 'POST', data: params });
};

// 公司风险信息
export function companyRisk(params = {}) {
  return send({ url: '/ipp/v3/company/risk', method: 'POST', data: params });
};

// 顶级分类列表
export function getHomeTopCategory(params = {}) {
  return send({ url: '/ipp/v3/home/top-category', method: 'POST', data: params });
};

// 消息列表
export function messageSelect(params = {}) {
  return send({ url: '/ipp/v3/message/select', method: 'POST', data: params });
};

// 消息列表-全部已读
export function messageReadAll(params = {}) {
  return send({ url: '/ipp/v3/message/read-all', method: 'POST', data: params });
};

//消息-已读
export function messageRead(params = {}) {
  return send({ url: '/ipp/v3/message/read', method: 'POST', data: params });
}

// 用户关联公司列表
export function userJoinCompanys(params = {}) {
  return send({ url: '/ipp/v3/user/join-companys', method: 'POST', data: params });
};

// 切换当前公司
export function userSwitchCompanys(params = {}) {
  return send({ url: '/ipp/v3/user/switch-companys', method: 'POST', data: params });
};

// OCR识别服务-营业执照
export function publicOcrBusinessLicense(params = {}) {
  return send({ url: '/ipp/v3/public/ocr-business-license', method: 'POST', data: params });
};

// OCR识别服务-身份证（正反面）
export function publicOcrIdCard(params = {}) {
  return send({ url: '/ipp/v3/public/ocr-idcard', method: 'POST', data: params });
};

export function supplierApplyInfo(params = {}) {
  return send({ url: '/ipp/v3/supplier-apply/info', method: 'POST', data: params });
};

